import {
  PageBlueprint,
  createFrontendPlugin,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import {
  compatWrapper,
  convertLegacyRouteRef,
  convertLegacyRouteRefs,
} from '@backstage/core-compat-api';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import { FOCUS_AREAS_TAB_PATH, engineeringExcellenceRouteRef } from './routes';

// Every Component gets the tab; one the entity database doesn't know shows a
// "not tracked" state rather than hiding the tab.
const serviceTab = EntityContentBlueprint.make({
  name: 'service',
  params: {
    path: FOCUS_AREAS_TAB_PATH,
    title: 'Focus Areas',
    filter: { kind: 'component' },
    loader: async () => {
      const { ServiceFocusAreaTab } = await import('./features/service-tab');
      return compatWrapper(<ServiceFocusAreaTab />);
    },
  },
});

// Standalone page: completion spans every Component, so it has no owning
// entity. `title`, `icon` and `routeRef` are what put it in the sidebar: without a
// routeRef the nav item has no href and the sidebar omits it.
const engineeringExcellencePage = PageBlueprint.make({
  name: 'engineering-excellence',
  params: {
    path: '/engineering-excellence',
    title: 'Engineering Excellence',
    icon: <FactCheckIcon />,
    routeRef: convertLegacyRouteRef(engineeringExcellenceRouteRef),
    loader: async () => {
      const { EngineeringExcellencePage } = await import(
        './features/dashboard'
      );
      return compatWrapper(<EngineeringExcellencePage />);
    },
  },
});

export const focusAreaTrackerPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'focus-area-tracker',
  extensions: [serviceTab, engineeringExcellencePage],
  routes: convertLegacyRouteRefs({
    engineeringExcellence: engineeringExcellenceRouteRef,
  }),
});
